export default "__VITE_ASSET__KwpuR8Jj__"